<template>
	<section class="view-signup-profilephoto">
		<header class="stepped-overlay-header">
			<ChalkyBrandingBadge size="md" />
			<h3>What do you look like?</h3>
			<p>Select an avatar or upload a photo</p>
		</header>

		<section class="fields stepped-overlay-content">
			<fieldset>
				<label>
					<h6>Enter password</h6>
					<input
						autocomplete="name"
						minlength="6"
						name="name"
						placeholder="John Doe"
						type="text"
						v-model="fullName"
					/>
				</label>
			</fieldset>
		</section>

		<section class="actions stepped-overlay-actions">
			<RouterLink class="button-secondary" v-bind:to="{ params: { step: 'enter-password' } }">Back</RouterLink>
			<RouterLink class="button-primary" v-bind:to="{ params: { step: 'favorite-games' } }">Continue</RouterLink>
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Signup
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewSignupProfilePhoto extends ViewBase {
		/**
		 * @type ChalkySticks.Model.User
		 */
		@Prop()
		protected userModel!: ChalkySticks.Model.User;
	}
</script>

<style lang="scss">
	.view-signup-profilephoto {
		// Not implemented
	}
</style>
